module.exports = __webpack_public_path__ + "pg.94f50b75e24428bdcf96.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pg.svg
// module chunks = styles